module.exports = __webpack_public_path__ + "ab3f7b0803d47598baeb7a29bee3af8b.png";